import { useEffect, useState } from 'react';

import { adminApi } from '../adminApi';

// The beta waitlist (TOM-634, ADR 0384), newest first.
interface BetaSignupRow {
  id: string;
  email: string;
  created_at: string;
}

export function AdminBetaSignups() {
  const [data, setData] = useState<{ total: number; signups: BetaSignupRow[] } | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      try {
        setData(await adminApi('/v1/admin/beta-signups'));
      } catch (err) {
        const e = err as { body?: { message?: string } };
        setError(e.body?.message ?? 'Failed to load the beta list.');
      }
    })();
  }, []);

  const emails = data === null ? '' : data.signups.map((s) => s.email).join('\n');

  return (
    <section className="admin-section">
      <header className="admin-section-header">
        <h1>Beta signups</h1>
        <span className="admin-count">{data === null ? '…' : `${data.total} total`}</span>
      </header>

      {error !== null ? <div className="admin-auth-banner error">{error}</div> : null}
      {data === null && error === null ? <p className="admin-loading-row">Loading…</p> : null}

      {data !== null ? (
        <>
          <p>
            <button
              type="button"
              className="btn"
              onClick={() => void navigator.clipboard.writeText(emails)}
            >
              Copy all emails
            </button>
          </p>
          <div className="scroll-x">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Joined</th>
                </tr>
              </thead>
              <tbody>
                {data.signups.map((s) => (
                  <tr key={s.id} data-testid={`admin-beta-row-${s.id}`}>
                    <td>{s.email}</td>
                    <td>{new Date(s.created_at).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : null}
    </section>
  );
}
